import { Img, Spinner } from "components";
import { convertFileToBase64 } from "pages/CreateRemit/documentation";
import { useCallback, useEffect, useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import Navbar from "components/Navbar/Index";
import { CheckedState } from "@radix-ui/react-checkbox";
import {
  submitDoc,
  verifyUserAndDocument,
  VerifyUserAndDocumentReqType,
} from "service/apis/Opportunities";
import { AxiosRequestConfig } from "axios";
import { useNavigate } from "react-router-dom";

type FileType = {
  file: string;
  doc_id: number;
};

interface PersonalDetails {
  expires_in: number;
  id: number;
  name: string;
  number: string;
  type: string;
  email: string;
  address: string;
  product: string;
}

export default function CollectDocs() {
  const [documentList, setDocumentList] = useState<FileType[]>([]);
  const [docList, setDocList] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [personalDetails, setPersonalDetails] = useState<PersonalDetails>();
  const [term1, setTerm1] = useState(true);
  const [term2, setTerm2] = useState(false);
  const [documentListWithoutBinary, setDocumentListWithoutBinary] = useState<{
    [key: string]: File;
  }>({});

  const getUploadedDocumentsCount = useCallback(() => {
    return Object.values(documentListWithoutBinary).filter((doc) => doc)
      ?.length;
  }, [documentListWithoutBinary]);

  const uuid = new URL(window.location.href).searchParams.get("uuid");
  const opportunity_id = new URL(window.location.href).searchParams.get(
    "opp_id",
  );

  const navigate = useNavigate();

  const fetchDocandContactMap = async () => {
    const payload: AxiosRequestConfig<VerifyUserAndDocumentReqType> = {
      params: {
        opportunity_id,
        uuid,
      },
    };
    try {
      const res = (await verifyUserAndDocument(payload)) as any;
      const data = res?.data?.result1;
      //   if( res?.data?.message === 'access denied'){
      //     navigate('/redirect/404',{state:{message:'Access Denied'}})
      //   }
      setDocList(() => res?.data?.documets);
      setPersonalDetails({
        expires_in: data?.exp_time,
        id: data?.id,
        name: data?._contacts?.[0]?.contactName,
        number: data?._contacts?.[0]?.contactNumber,
        type: data?._contacts?.[0]?.contactPersonType,
        email: data?._contacts?.[0]?.contactEmail,
        address: data?._contacts?.[0]?.contactAddress,
        product: data?._product?.name,
      });
      console.log(res.data);
    } catch (error) {
      navigate("/redirect/404", {
        state: {
          message: "Link expired",
          description:
            "Your link may have expired or you don't have access to this page",
        },
      });
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDocandContactMap();
  }, []);

  const handleFileChange = useCallback(
    (fieldName: string, id: number) =>
      async (event: React.ChangeEvent<HTMLInputElement>) => {
        console.log(documentList);
        const file = event.target.files?.[0];
        if (file) {
          setDocumentListWithoutBinary({
            ...documentListWithoutBinary,
            [fieldName]: file,
          });

          const base64String = await convertFileToBase64(file);

          // Create the file data object
          const fileData: FileType = {
            // access: "public",
            // path: base64String,
            // name: id,
            // type: file.type,
            // size: file.size,
            // mime: file.type,
            // meta: {},
            file: base64String,
            doc_id: id,
          };

          const existingDocIndex = documentList.findIndex(
            (doc) => doc.doc_id === id,
          );

          if (existingDocIndex !== -1) {
            const updatedDocumentList = [...documentList];
            updatedDocumentList[existingDocIndex] = fileData;
            setDocumentList(updatedDocumentList);
          } else {
            setDocumentList([...documentList, fileData]);
          }
        }
      },
    [documentList, documentListWithoutBinary],
  );

  const handleTerm1Change = (checked: CheckedState) => {
    setTerm1(checked === true);
  };

  const handleTerm2Change = (checked: CheckedState) => {
    setTerm2(checked === true);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("opportunity_id", opportunity_id as string);
    formData.append("uuid", uuid as string);
    formData.append("consent", "true");
    documentList.forEach((doc) => {
      formData.append(
        "doc_name[]",
        JSON.stringify({
          doc_id: doc.doc_id,
          file: doc.file,
        }),
      );
    });

    const payload = {
      data: formData,
    };

    setLoading(true);

    try {
      const res = (await submitDoc(payload)) as any;
      if (res?.status === 200) {
        setSubmitted(true);
        setDocList(res?.data?.documents as any);
      }
      console.log(res);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <div className="flex p-4 flex-col h-screen gap-2.5 font-inter">
      {loading && <Spinner />}
      <Navbar className="flex justify-start sm:flex">
        <div className=" w-full flex justify-between">
          <div className=" flex gap-3 items-center">
            <div className="gap-2 flex items-center">
              <Img src="/images/image.png" className="h-8" alt="" />
            </div>
          </div>
          {/* <div className="flex gap-3">
                        {
                            <AlertDialog>
                                <AlertDialogTrigger>
                                    <button className="rounded-lg py-[11px] px-4 border bg-gray-button-gray-lite border-gray-border-gray-lite">
                                        Cancel
                                    </button>
                                </AlertDialogTrigger>
                                <AlertDialogPortal>
                                    <AlertDialogOverlay className=" bg-black-900 bg-opacity-60 animate-overlayShow fixed inset-0" />
                                    <AlertDialogContent className="bg-white-A700 rounded-lg p-0 max-w-2xl animate-contentShow">
                                        <AlertDialogHeader className="flex text-left gap-4 pt-8 pb-4 px-10 ">
                                            <AlertDialogTitle className="font-bold text-xl leading-7 tracking-[2%] text-black-label">
                                                Are you absolutely sure?
                                            </AlertDialogTitle>
                                            <AlertDialogDescription className="font-medium text-base leading-6 tracking-[2%] text-[#7E7E7E] ">
                                                This action can not be undone. This will permanently
                                                cancel the ongoing progress.
                                            </AlertDialogDescription>
                                        </AlertDialogHeader>
                                        <AlertDialogFooter className="flex justify-end items-center gap-2.5 py-5 px-10 flex-row rounded-b-lg bg-gray-button-gray-lite">
                                            <AlertDialogCancel
                                                className=" m-0 rounded-lg border-blue-700 border py-[11px] px-4 text-blue-700"
                                                asChild
                                            >
                                                <button>Close</button>
                                            </AlertDialogCancel>
                                            <AlertDialogAction
                                                className="rounded-lg border-blue-700 py-[11px] px-4 bg-blue-700 border text-white-A700"
                                                asChild
                                            >
                                                <button className="" >
                                                    Confirm
                                                </button>
                                            </AlertDialogAction>
                                        </AlertDialogFooter>
                                    </AlertDialogContent>
                                </AlertDialogPortal>
                            </AlertDialog>
                        }
                    </div> */}
        </div>
      </Navbar>
      <div className="flex-1 sm:bg-white-A700 sm:rounded-xl h-full flex-grow sm:overflow-auto overflow-hidden">
        <main className=" sm:flex-col flex gap-5 justify-between h-full">
          <section className="w-full overflow-auto gap-8 flex flex-col h-full rounded-xl p-3 bg-white-A700">
            <div className=" flex p-3 border-b w-full justify-between items-center">
              <div className="w-full  flex flex-col gap-2">
                <h3 className=" font-semibold leading-4 text-lg text-black-label">
                  {false
                    ? "Upload Documents"
                    : `Secure document upload for ${personalDetails?.name}`}
                </h3>
                {!submitted && (
                  <p className="font-normal leading-[22.4px] text-sm text-[#7E7E7E]">
                    Please upload documents to proceed with your order.
                  </p>
                )}
              </div>
            </div>
            {submitted ? (
              <div
                style={{
                  background:
                    "linear-gradient(90deg, #FFFFFF 0%, #FAFBFF 100%)",
                  boxShadow: "1px 1px 7px 0px #2252A71A",
                }}
                className="py-5 px-8 flex flex-col gap-8 rounded-xl border"
              >
                <div className="flex justify-between">
                  <div className="flex flex-col w-2/3 gap-8">
                    <div className="">
                      <p className="text-lg font-semibold text-blue-700">
                        Thank you for submitting your documents.
                      </p>
                    </div>
                    <div className="pl-4">
                      <ul className=" list-none flex flex-col gap-3">
                        <li className="font-normal text-sm text-[#5E5E5E]">
                          We will review your documents and get back to you
                          soon.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="">
                    <svg
                      width="74"
                      height="97"
                      viewBox="0 0 74 97"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_i_2320_85699)">
                        <path
                          d="M37 0C20.47 0 7 13.47 7 30C7 46.53 20.47 60 37 60C53.53 60 67 46.53 67 30C67 13.47 53.53 0 37 0ZM51.34 23.1L34.33 40.11C33.91 40.53 33.34 40.77 32.74 40.77C32.14 40.77 31.57 40.53 31.15 40.11L22.66 31.62C21.79 30.75 21.79 29.31 22.66 28.44C23.53 27.57 24.97 27.57 25.84 28.44L32.74 35.34L48.16 19.92C49.03 19.05 50.47 19.05 51.34 19.92C52.21 20.79 52.21 22.2 51.34 23.1Z"
                          fill="#3FB73D"
                        />
                      </g>
                      <path
                        d="M6.95605 82.4929C6.90302 82.0223 6.68427 81.6577 6.2998 81.3991C5.91534 81.1373 5.43143 81.0064 4.8481 81.0064C4.43049 81.0064 4.06922 81.0727 3.76429 81.2053C3.45937 81.3345 3.22239 81.5135 3.05336 81.7422C2.88764 81.9676 2.80478 82.2244 2.80478 82.5128C2.80478 82.7547 2.86112 82.9635 2.97381 83.1392C3.08981 83.3149 3.24062 83.4624 3.42623 83.5817C3.61515 83.6977 3.81732 83.7955 4.03276 83.875C4.24819 83.9512 4.45534 84.0142 4.65421 84.0639L5.64853 84.3224C5.97334 84.402 6.30643 84.5097 6.64782 84.6456C6.9892 84.7815 7.30572 84.9605 7.59739 85.1825C7.88906 85.4046 8.12438 85.6797 8.30336 86.0078C8.48565 86.3359 8.57679 86.7287 8.57679 87.1861C8.57679 87.7628 8.42765 88.2749 8.12935 88.7223C7.83437 89.1697 7.40516 89.5227 6.84171 89.7812C6.28158 90.0398 5.60378 90.169 4.80833 90.169C4.04602 90.169 3.38645 90.0481 2.82963 89.8061C2.27282 89.5642 1.83697 89.2211 1.52211 88.777C1.20724 88.3295 1.03323 87.7992 1.00009 87.1861H2.54128C2.57111 87.554 2.69043 87.8606 2.89924 88.1058C3.11136 88.3478 3.38148 88.5284 3.70961 88.6477C4.04105 88.7637 4.40397 88.8217 4.79838 88.8217C5.23257 88.8217 5.6187 88.7538 5.95676 88.6179C6.29815 88.4787 6.56661 88.2865 6.76216 88.0412C6.95771 87.7926 7.05549 87.5026 7.05549 87.1712C7.05549 86.8696 6.96931 86.6226 6.79696 86.4304C6.62793 86.2382 6.39758 86.0791 6.10591 85.9531C5.81756 85.8272 5.49109 85.7161 5.12651 85.62L3.92338 85.2919C3.10804 85.0698 2.46174 84.7434 1.98446 84.3125C1.51051 83.8816 1.27353 83.3116 1.27353 82.6023C1.27353 82.0156 1.43262 81.5036 1.7508 81.0661C2.06898 80.6286 2.49985 80.2888 3.04341 80.0469C3.58697 79.8016 4.20014 79.679 4.8829 79.679C5.5723 79.679 6.18049 79.8 6.70748 80.0419C7.23778 80.2839 7.65539 80.617 7.96032 81.0412C8.26524 81.4621 8.42433 81.946 8.43759 82.4929H6.95605ZM15.1306 86.8331V82.3636H16.6221V90H15.1604V88.6776H15.0809C14.9052 89.0852 14.6235 89.425 14.2357 89.6967C13.8512 89.9652 13.3723 90.0994 12.7989 90.0994C12.3084 90.0994 11.8742 89.9917 11.4964 89.7763C11.1218 89.5575 10.8269 89.2344 10.6114 88.8068C10.3993 88.3793 10.2932 87.8506 10.2932 87.2209V82.3636H11.7797V87.0419C11.7797 87.5623 11.9239 87.9766 12.2123 88.2848C12.5006 88.593 12.8751 88.7472 13.3358 88.7472C13.6143 88.7472 13.891 88.6776 14.1661 88.5384C14.4445 88.3991 14.6749 88.1887 14.8572 87.907C15.0428 87.6252 15.1339 87.2673 15.1306 86.8331ZM21.836 90.1541C21.0969 90.1541 20.4606 89.9867 19.9269 89.652C19.3966 89.3139 18.989 88.8482 18.7039 88.255C18.4189 87.6617 18.2764 86.9822 18.2764 86.2166C18.2764 85.4411 18.4222 84.7566 18.7139 84.1634C19.0055 83.5668 19.4165 83.1011 19.9468 82.7663C20.4771 82.4316 21.1019 82.2642 21.8211 82.2642C22.4011 82.2642 22.9182 82.3719 23.3722 82.5874C23.8263 82.7995 24.1926 83.0978 24.471 83.4822C24.7527 83.8667 24.9201 84.3158 24.9731 84.8295H23.5264C23.4468 84.4716 23.2645 84.1634 22.9795 83.9048C22.6978 83.6463 22.3199 83.517 21.846 83.517C21.4317 83.517 21.0687 83.6264 20.7572 83.8452C20.449 84.0606 20.2087 84.3688 20.0363 84.7699C19.864 85.1676 19.7778 85.6383 19.7778 86.1818C19.7778 86.7386 19.8623 87.2192 20.0313 87.6236C20.2004 88.0279 20.439 88.3411 20.7472 88.5632C21.0588 88.7853 21.425 88.8963 21.846 88.8963C22.1277 88.8963 22.3829 88.8449 22.6116 88.7422C22.8436 88.6361 23.0375 88.4853 23.1933 88.2898C23.3524 88.0942 23.4634 87.8589 23.5264 87.5838H24.9731C24.9201 88.0777 24.7593 88.5185 24.4909 88.9062C24.2224 89.294 23.8628 89.599 23.412 89.821C22.9646 90.0431 22.4392 90.1541 21.836 90.1541ZM29.7794 90.1541C29.0403 90.1541 28.4039 89.9867 27.8703 89.652C27.34 89.3139 26.9323 88.8482 26.6473 88.255C26.3622 87.6617 26.2197 86.9822 26.2197 86.2166C26.2197 85.4411 26.3656 84.7566 26.6572 84.1634C26.9489 83.5668 27.3599 83.1011 27.8902 82.7663C28.4205 82.4316 29.0452 82.2642 29.7645 82.2642C30.3445 82.2642 30.8615 82.3719 31.3156 82.5874C31.7697 82.7995 32.1359 83.0978 32.4143 83.4822C32.6961 83.8667 32.8634 84.3158 32.9165 84.8295H31.4697C31.3902 84.4716 31.2079 84.1634 30.9229 83.9048C30.6411 83.6463 30.2633 83.517 29.7893 83.517C29.375 83.517 29.0121 83.6264 28.7006 83.8452C28.3923 84.0606 28.152 84.3688 27.9797 84.7699C27.8073 85.1676 27.7211 85.6383 27.7211 86.1818C27.7211 86.7386 27.8057 87.2192 27.9747 87.6236C28.1437 88.0279 28.3824 88.3411 28.6906 88.5632C29.0022 88.7853 29.3684 88.8963 29.7893 88.8963C30.0711 88.8963 30.3263 88.8449 30.555 88.7422C30.787 88.6361 30.9809 88.4853 31.1366 88.2898C31.2957 88.0942 31.4068 87.8589 31.4697 87.5838H32.9165C32.8634 88.0777 32.7027 88.5185 32.4342 88.9062C32.1657 89.294 31.8061 89.599 31.3554 89.821C30.9079 90.0431 30.3826 90.1541 29.7794 90.1541ZM37.7973 90.1541C37.045 90.1541 36.397 89.9934 35.8534 89.6719C35.3132 89.3471 34.8956 88.8913 34.6006 88.3047C34.3089 87.7147 34.1631 87.0237 34.1631 86.2315C34.1631 85.4493 34.3089 84.7599 34.6006 84.1634C34.8956 83.5668 35.3066 83.1011 35.8335 82.7663C36.3638 82.4316 36.9836 82.2642 37.6929 82.2642C38.1238 82.2642 38.5414 82.3355 38.9458 82.478C39.3501 82.6205 39.713 82.8442 40.0345 83.1491C40.356 83.4541 40.6096 83.8501 40.7952 84.3374C40.9808 84.8213 41.0736 85.4096 41.0736 86.1023V86.6293H35.0033V85.5156H39.6169C39.6169 85.1245 39.5374 84.7782 39.3783 84.4766C39.2192 84.1716 38.9955 83.9313 38.7071 83.7557C38.4221 83.58 38.0873 83.4922 37.7029 83.4922C37.2852 83.4922 36.9207 83.5949 36.6091 83.8004C36.3009 84.0026 36.0622 84.2678 35.8932 84.5959C35.7275 84.9207 35.6446 85.2737 35.6446 85.6548V86.5249C35.6446 87.0353 35.7341 87.4695 35.9131 87.8274C36.0954 88.1854 36.3489 88.4588 36.6737 88.6477C36.9986 88.8333 37.378 88.9261 37.8122 88.9261C38.094 88.9261 38.3508 88.8864 38.5828 88.8068C38.8148 88.724 39.0154 88.6013 39.1844 88.4389C39.3534 88.2765 39.4827 88.076 39.5722 87.8374L40.9791 88.0909C40.8664 88.5052 40.6643 88.8681 40.3726 89.1797C40.0843 89.4879 39.7213 89.7282 39.2838 89.9006C38.8496 90.0696 38.3541 90.1541 37.7973 90.1541ZM48.4452 84.228L47.0979 84.4666C47.0416 84.2943 46.9521 84.1302 46.8295 83.9744C46.7101 83.8187 46.5477 83.6911 46.3422 83.5916C46.1367 83.4922 45.8799 83.4425 45.5716 83.4425C45.1507 83.4425 44.7994 83.5369 44.5177 83.7259C44.2359 83.9115 44.0951 84.1518 44.0951 84.4467C44.0951 84.7019 44.1895 84.9074 44.3785 85.0632C44.5674 85.219 44.8723 85.3466 45.2932 85.446L46.5063 85.7244C47.209 85.8868 47.7326 86.1371 48.0773 86.4751C48.422 86.8132 48.5944 87.2524 48.5944 87.7926C48.5944 88.25 48.4618 88.6577 48.1966 89.0156C47.9348 89.3703 47.5686 89.6487 47.0979 89.8509C46.6306 90.053 46.0887 90.1541 45.4722 90.1541C44.6171 90.1541 43.9194 89.9718 43.3792 89.6072C42.8389 89.2393 42.5075 88.7173 42.3849 88.0412L43.8216 87.8224C43.9111 88.197 44.0951 88.4804 44.3735 88.6726C44.6519 88.8615 45.0148 88.956 45.4623 88.956C45.9495 88.956 46.3389 88.8549 46.6306 88.6527C46.9223 88.4472 47.0681 88.197 47.0681 87.902C47.0681 87.6634 46.9786 87.4628 46.7996 87.3004C46.624 87.138 46.3538 87.0154 45.9893 86.9325L44.6966 86.6491C43.984 86.4867 43.4571 86.2282 43.1157 85.8736C42.7776 85.5189 42.6086 85.0698 42.6086 84.5263C42.6086 84.0755 42.7345 83.6811 42.9864 83.343C43.2383 83.005 43.5863 82.7415 44.0305 82.5526C44.4746 82.3603 44.9833 82.2642 45.5567 82.2642C46.382 82.2642 47.0316 82.4432 47.5056 82.8011C47.9796 83.1558 48.2928 83.6314 48.4452 84.228ZM55.9511 84.228L54.6038 84.4666C54.5474 84.2943 54.4579 84.1302 54.3353 83.9744C54.216 83.8187 54.0536 83.6911 53.8481 83.5916C53.6426 83.4922 53.3857 83.4425 53.0775 83.4425C52.6566 83.4425 52.3052 83.5369 52.0235 83.7259C51.7418 83.9115 51.6009 84.1518 51.6009 84.4467C51.6009 84.7019 51.6954 84.9074 51.8843 85.0632C52.0732 85.219 52.3782 85.3466 52.7991 85.446L54.0122 85.7244C54.7148 85.8868 55.2385 86.1371 55.5832 86.4751C55.9279 86.8132 56.1002 87.2524 56.1002 87.7926C56.1002 88.25 55.9677 88.6577 55.7025 89.0156C55.4407 89.3703 55.0744 89.6487 54.6038 89.8509C54.1365 90.053 53.5945 90.1541 52.9781 90.1541C52.123 90.1541 51.4253 89.9718 50.885 89.6072C50.3448 89.2393 50.0133 88.7173 49.8907 88.0412L51.3275 87.8224C51.417 88.197 51.6009 88.4804 51.8794 88.6726C52.1578 88.8615 52.5207 88.956 52.9681 88.956C53.4553 88.956 53.8448 88.8549 54.1365 88.6527C54.4281 88.4472 54.574 88.197 54.574 87.902C54.574 87.6634 54.4845 87.4628 54.3055 87.3004C54.1298 87.138 53.8597 87.0154 53.4951 86.9325L52.2025 86.6491C51.4899 86.4867 50.9629 86.2282 50.6215 85.8736C50.2835 85.5189 50.1144 85.0698 50.1144 84.5263C50.1144 84.0755 50.2404 83.6811 50.4923 83.343C50.7442 83.005 51.0922 82.7415 51.5363 82.5526C51.9804 82.3603 52.4892 82.2642 53.0626 82.2642C53.8879 82.2642 54.5375 82.4432 55.0115 82.8011C55.4854 83.1558 55.7986 83.6314 55.9511 84.228ZM61.3689 82.3636V83.5568H57.0535V82.3636H61.3689ZM58.2368 90V81.4787C58.2368 81.0014 58.3412 80.6053 58.55 80.2905C58.7588 79.9723 59.0355 79.7353 59.3802 79.5795C59.7249 79.4205 60.0995 79.3409 60.5038 79.3409C60.8021 79.3409 61.0573 79.3658 61.2694 79.4155C61.4816 79.4619 61.639 79.505 61.7417 79.5447L61.3937 80.7479C61.3241 80.728 61.2346 80.7048 61.1253 80.6783C61.0159 80.6484 60.8833 80.6335 60.7275 80.6335C60.3663 80.6335 60.1077 80.723 59.952 80.902C59.7995 81.081 59.7233 81.3395 59.7233 81.6776V90H58.2368ZM67.74 86.8331V82.3636H69.2314V90H67.7698V88.6776H67.6903C67.5146 89.0852 67.2329 89.425 66.8451 89.6967C66.4606 89.9652 65.9817 90.0994 65.4083 90.0994C64.9178 90.0994 64.4836 89.9917 64.1057 89.7763C63.7312 89.5575 63.4362 89.2344 63.2208 88.8068C63.0087 88.3793 62.9026 87.8506 62.9026 87.2209V82.3636H64.3891V87.0419C64.3891 87.5623 64.5333 87.9766 64.8216 88.2848C65.11 88.593 65.4845 88.7472 65.9452 88.7472C66.2236 88.7472 66.5004 88.6776 66.7755 88.5384C67.0539 88.3991 67.2842 88.1887 67.4665 87.907C67.6521 87.6252 67.7433 87.2673 67.74 86.8331ZM72.7153 79.8182V90H71.2288V79.8182H72.7153Z"
                        fill="#23AB28"
                      />
                      <defs>
                        <filter
                          id="filter0_i_2320_85699"
                          x="7"
                          y="0"
                          width="60"
                          height="60"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="BackgroundImageFix"
                            result="shape"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dx="5" dy="1" />
                          <feComposite
                            in2="hardAlpha"
                            operator="arithmetic"
                            k2="-1"
                            k3="1"
                          />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.0991137 0 0 0 0 0.562537 0 0 0 0 0.117651 0 0 0 1 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="shape"
                            result="effect1_innerShadow_2320_85699"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="rounded-xl py-2.5 px-4 bg-[#F2F7FF]">
                  <ul>
                    <li className="font-normal text-base">
                      The link is valid only for {personalDetails?.expires_in}{" "}
                      hour Please make sure to upload your documents before
                      expiry of the link.
                    </li>
                  </ul>
                </div>
                <div className="lg:hidden">
                  <h3 className="pl-3 font-normal text-base">
                    Personal Details
                  </h3>
                  <div className="pt-5 pb-10 px-5  rounded-xl bg-custom-calc-gradient  gap-10">
                    <div className="divide-y divide-neutral-400_1 gap-5 flex flex-col">
                      <div className="w-full">
                        <div className="w-full grid sm:grid-cols-1 grid-cols-2 gap-5">
                          <div className="flex justify-between">
                            <p className="font-normal text-sm text-[#666666]">
                              Name
                            </p>
                            <p className=" font-medium text-sm text-black-label">
                              {personalDetails?.name}
                            </p>
                          </div>
                          <div className="flex justify-between">
                            <p className="font-normal text-sm text-[#666666]">
                              Phone
                            </p>
                            <p className=" font-medium text-sm text-black-label">
                              {personalDetails?.number}
                            </p>
                          </div>
                          <div className="flex justify-between">
                            <p className="font-normal text-sm text-[#666666]">
                              Email
                            </p>
                            <p className=" font-medium text-sm text-black-label">
                              {personalDetails?.email
                                ? personalDetails?.email
                                : "N/A"}
                            </p>
                          </div>
                          <div className="flex justify-between">
                            <p className="font-normal text-sm text-[#666666]">
                              Product
                            </p>
                            <p className=" font-medium text-sm text-black-label">
                              {personalDetails?.product}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rounded-xl h-full flex flex-col gap-5 w-full px-5 py-2.5">
                  <div className="flex overflow-auto relative h-auto flex-col gap-5 w-full">
                    <div className="flex gap-8 flex-col pb-8">
                      <div className="flex justify-between">
                        <div className="flex gap-2 items-center">
                          <div className="">
                            <Img src="/images/remit/documentation.svg" alt="" />
                          </div>
                          <div className="text-blue-700">Upload Documents</div>
                        </div>
                        <small className=" italic pr-2">
                          <span className="text-blue-700 text-sm font-medium">
                            {getUploadedDocumentsCount()}/{docList?.length}
                          </span>{" "}
                          uploaded
                        </small>
                      </div>
                      <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-3 gap-6">
                        {docList?.map((doc: any) => (
                          <div
                            key={doc?.doc_id}
                            className="flex gap-2 flex-col w-full"
                          >
                            <h3>{doc?.filename}</h3>
                            <div
                              className={`py-1.5 px-3.5 justify-between border rounded-md flex ${documentListWithoutBinary[doc?.filename]?.name && "bg-[#F2F7FF] border-none"}`}
                            >
                              <div className="flex gap-3 items-center overflow-hidden">
                                <Img src="/images/remit/file.svg" alt="" />
                                <p className="truncate text-[#999999] text-sm font-normal">
                                  {documentListWithoutBinary[doc?.filename]
                                    ?.name
                                    ? documentListWithoutBinary[doc?.filename]
                                      ?.name
                                    : "No file choosen"}
                                </p>
                              </div>
                              <label
                                htmlFor={doc?.filename}
                                className="text-blue-700 cursor-pointer border border-blue-700 text-white ml-2 px-4 py-2 rounded-lg whitespace-nowrap"
                              >
                                {documentListWithoutBinary[doc?.filename]?.name
                                  ? "Re-upload"
                                  : "Upload"}
                              </label>
                              <input
                                name={doc?.filename}
                                type="file"
                                id={doc?.filename}
                                className="hidden cursor-pointer"
                                accept="application/pdf,image/*"
                                onChange={handleFileChange(
                                  doc?.filename,
                                  doc?.doc_id,
                                )}
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="px-5 flex flex-col gap-3">
                    <ul className=" list-disc">
                      <li className="font-medium text-base">
                        I authorize MoneeFlo (”Trafex India Pvt. Ltd.”) to :
                      </li>
                    </ul>
                    <div className="flex items-center space-x-2">
                      <Checkbox
                        id="terms1"
                        checked={term1}
                        onCheckedChange={handleTerm1Change}
                      />
                      <label
                        htmlFor="terms1"
                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                      >
                        Use the uploaded documents for processing my order.
                      </label>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Checkbox
                        id="terms2"
                        checked={term2}
                        onCheckedChange={handleTerm2Change}
                      />
                      <label
                        htmlFor="terms2"
                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                      >
                        Save these documents for future use.
                      </label>
                    </div>
                  </div>
                  <button
                    onClick={handleSubmit}
                    disabled={
                      !term1 || !(docList?.length === documentList?.length)
                    }
                    className=" disabled:opacity-40 rounded-lg w-fit py-[11px] px-4 border bg-blue-700 text-white-A700"
                  >
                    Submit
                  </button>
                </div>
              </>
            )}
          </section>
          <section className="w-5/12 md:hidden rounded-xl p-3 bg-white-A700">
            <h3 className="pl-3 font-normal text-base">Personal Details</h3>
            <div className="pt-5 pb-10 px-5 rounded-xl bg-custom-calc-gradient  gap-10">
              <div className="divide-y divide-neutral-400_1 gap-5 flex flex-col">
                <div className="w-full">
                  <div className="w-full flex flex-col gap-5">
                    <div className="flex justify-between">
                      <p className="font-normal text-sm text-[#666666]">Name</p>
                      <p className=" font-medium text-sm text-black-label">
                        {personalDetails?.name}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="font-normal text-sm text-[#666666]">
                        Phone
                      </p>
                      <p className=" font-medium text-sm text-black-label">
                        {personalDetails?.number}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="font-normal text-sm text-[#666666]">
                        Email
                      </p>
                      <p className=" font-medium text-sm text-black-label">
                        {personalDetails?.email
                          ? personalDetails?.email
                          : "N/A"}
                      </p>
                    </div>
                    <div className="flex justify-between">
                      <p className="font-normal text-sm text-[#666666]">
                        Product
                      </p>
                      <p className=" font-medium text-sm text-black-label">
                        {personalDetails?.product}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {submitted && (
              <div className="w-full divide-neutral-400_1 px-5 py-3">
                <div className="w-full flex flex-col gap-5">
                  {docList?.map((doc: any) => (
                    <div key={doc?.filename} className="flex justify-between">
                      <p className="font-normal text-sm text-[#666666]">
                        {doc?.filename}{" "}
                      </p>
                      <p className=" font-medium text-sm text-black-label flex items-center gap-2">
                        Uploaded
                        <svg
                          width="19"
                          height="19"
                          viewBox="0 0 19 19"
                          fill="none"
                          xmlns="http:www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.5 0.5C4.541 0.5 0.5 4.541 0.5 9.5C0.5 14.459 4.541 18.5 9.5 18.5C14.459 18.5 18.5 14.459 18.5 9.5C18.5 4.541 14.459 0.5 9.5 0.5ZM13.802 7.43L8.699 12.533C8.573 12.659 8.402 12.731 8.222 12.731C8.042 12.731 7.871 12.659 7.745 12.533L5.198 9.986C4.937 9.725 4.937 9.293 5.198 9.032C5.459 8.771 5.891 8.771 6.152 9.032L8.222 11.102L12.848 6.476C13.109 6.215 13.541 6.215 13.802 6.476C14.063 6.737 14.063 7.16 13.802 7.43Z"
                            fill="#3FB73D"
                          />
                        </svg>
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </section>
        </main>
      </div>
    </div>
  );
}
